import * as React from 'react';
import classnames from 'classnames';
const List = ({ className = '', maxHeight = '', title = '', dataSource = [], labelAlign = 'top', labelWidth = '30%', }) => {
    return dataSource.length ? (React.createElement("div", { className: classnames('op-card', 'op-card-list', className, {
            'op-card-max-height': maxHeight,
        }) },
        title ? React.createElement("div", { className: 'op-card-title' }, title) : null,
        React.createElement("div", { className: classnames('op-card-list-content', {
                'op-card-scroll': maxHeight,
            }) }, dataSource.map((item) => {
            const { label, value } = item;
            const itemLabelWidth = labelAlign === 'left' && labelWidth ? labelWidth : 'auto';
            return (React.createElement("div", { className: classnames('op-card-list-item', `label-align-${labelAlign}`) },
                React.createElement("div", { className: 'item-label', style: { width: itemLabelWidth } }, label),
                value ? React.createElement("div", { className: 'item-value' }, value) : null));
        })))) : null;
};
export default List;
